import { apiClient } from '../../../api/common/axios';

interface IntegrationOauthInitiateResponse {
	authorization_url: string;
}

/**
 * Initiates the OAuth flow for an integration.
 * Can be used standalone for programmatic OAuth initiation.
 */
export async function initiateIntegrationOauth(
	integrationId: string,
	integrationType: string,
	options?: {
		openInNewTab?: boolean;
		returnUrl?: string;
	}
): Promise<void> {
	const { openInNewTab = false, returnUrl = '/settings/connected-accounts' } =
		options || {};

	const response = await apiClient.get(
		`/integration_v2/integrations/${integrationId}/${integrationType}/oauth/initiate/`,
		{ params: { return_url: returnUrl } }
	);
	const data = response.data as IntegrationOauthInitiateResponse;

	if (openInNewTab) {
		const oauthWindow = window.open(data.authorization_url, '_blank');
		if (!oauthWindow) {
			// Popup was blocked, fall back to redirect
			window.location.href = data.authorization_url;
		}
	} else {
		window.location.href = data.authorization_url;
	}
}
